var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersoncomponent = function SvgPersoncomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C2.5 0 1.333 1.076 1.333 2.375 1.333 3.711 2.5 4.75 4 4.75c1.458 0 2.667-1.04 2.667-2.375C6.667 1.076 5.458 0 4 0Zm2 5.344h-.5c-.958.408-2.042.408-3.042 0H2c-1.125 0-2 .816-2 1.781v5.047c0 .52.417.89 1 .89h.667v5.047c0 .52.416.891 1 .891h2.666c.542 0 1-.371 1-.89v-5.047H7c.542 0 1-.372 1-.891V7.125c0-.965-.917-1.781-2-1.781Z",
    fill: "current"
  })));
};
export default SvgPersoncomponent;